import { useTranslation, Trans } from 'react-i18next';
import { User } from '../../models/UserServerData';
import { IconCheckCircleFilled } from '../../shared/components/icons';

interface ReferrerSectionProps {
  serverData: { referrer: User };
}

export function ReferrerSection({ serverData }: ReferrerSectionProps) {
  const { t } = useTranslation();
  const { referrer } = serverData;
  return (
    <div className="mx-auto mb-3 mt-3 h-auto w-full max-w-[530px] rounded bg-[#fafafa] p-12 lg:mb-0 lg:mt-0">
      <h2 className="mb-12 hidden text-center text-2xl font-medium lg:block">
        <Trans
          i18nKey="referralSignup.credit-given"
          t={t}
          values={{ referrer: `${referrer.first_name} ${referrer.last_name}` }}
        />
      </h2>
      <section className="-mt-3 mb-12 space-y-1">
        <div className="flex space-x-1">
          <IconCheckCircleFilled className="shrink-0 text-brand-blue" />
          <span className="font-normal text-[#454745]">{t('referralSignup.save-on-first')}</span>
        </div>
        <div className="flex space-x-1">
          <IconCheckCircleFilled className="shrink-0 text-brand-blue" />
          <span className="font-normal text-[#454745]">{t('referralSignup.use-ai')}</span>
        </div>
        <div className="flex space-x-1">
          <IconCheckCircleFilled className="shrink-0 text-brand-blue" />
          <span className="font-normal text-[#454745]">{t('referralSignup.fast-turnaround')}</span>
        </div>
        <div className="flex space-x-1">
          <IconCheckCircleFilled className="shrink-0 text-brand-blue" />
          <span className="font-normal text-[#454745]">{t('referralSignup.reviewed-by-expert')}</span>
        </div>
      </section>
      <div className="mb-12 flex justify-between">
        <div
          className="trustpilot-widget flex-1"
          data-locale="en-US"
          data-template-id="53aa8807dec7e10d38f59f32"
          data-businessunit-id="5fad88459a4f790001addb47"
          data-style-height="150px"
          data-style-width="100%"
          data-theme="light"
        >
          <a href="https://www.trustpilot.com/review/supervisas.com" target="_blank" rel="noopener noreferrer">
            Trustpilot
          </a>
        </div>
        <div className="mt-1 flex-1">
          <a href="https://www.bbb.org/ca/on/kitchener/profile/immigration-consultant/supervisas-0107-1396462/#sealclick">
            <img
              src="https://supervisa-statics-production.s3.amazonaws.com/static/local/img/BBB.png"
              alt="Visit our Better Business Bureau page"
            />
          </a>
        </div>
      </div>
      <div className="-mt-16 mb-6 text-center text-xl font-semibold text-slate-700 lg:-mt-6">
        {t('referralSignup.used-by')}
      </div>
      <div className="mx-auto mb-12 flex flex-wrap items-center justify-center justify-items-center gap-6">
        <img
          src="https://supervisa-statics-production.s3.amazonaws.com/static/local/img/Techstars.png"
          className="w-[120px]"
          alt="Techstars logo"
        />
        <img
          src="https://supervisa-statics-production.s3.amazonaws.com/static/local/img/velocity.png"
          className="w-[120px]"
          alt="Velocity logo"
        />
        <img
          src="https://supervisa-statics-production.s3.amazonaws.com/static/local/img/The_ACCELERATOR_CENTRE.png"
          className="w-[120px]"
          alt="Accelerator Centre logo"
        />
        <img
          src="https://supervisa-statics-production.s3.amazonaws.com/static/local/img/DMZ-logo.png"
          className="w-[120px]"
          alt="DMZ logo"
        />
        <img
          src="https://supervisa-statics-production.s3.amazonaws.com/static/local/img/Treefrog-logo.png"
          className="w-[120px]"
          alt="Treefrog Accelerator logo"
        />
        <img
          src="https://supervisa-statics-production.s3.amazonaws.com/static/local/img/y-space-logo.png"
          className="w-[120px]"
          alt="YSpace logo"
        />
      </div>
      <div className="mt-3 text-center font-medium text-slate-600">{t('referralSignup.and-many-more')}</div>
    </div>
  );
}
